import { ApiService, LabStainList } from "pwapi";

import SelectSearchInput from "components/admin/edit/SelectSearchInput";
import { FieldResponse } from "components/admin/types/adminTypes";

type LabStainResponse = Omit<FieldResponse, "object"> & {
  object?: LabStainList;
};

const LabStainOption = ({ object }: LabStainResponse) => {
  const stain = object?.stain;
  return (
    <div className="LabStainOption">
      {object ? (
        <>
          <strong>{stain?.abbreviation}</strong> ({stain?.name})
        </>
      ) : (
        <>...</>
      )}
    </div>
  );
};

const mapLabStainsToOption = (labStains: LabStainList[]): LabStainResponse[] =>
  labStains.map((labStain) => ({
    value: labStain.id?.toString() || "",
    label: `${labStain.stain?.abbreviation} (${labStain.stain?.name})`,
    object: labStain,
  }));

const LabStainInput = ({
  value,
  onChange,
  serviceOptions,
}: {
  value?: LabStainList;
  onChange: (value?: LabStainList) => void;
  serviceOptions?: Partial<Parameters<typeof ApiService.listLabStainLists>[0]>;
}) => {
  return (
    <SelectSearchInput
      id="optional_lab_stain"
      label="Lab Order (Optional)"
      field="lab_stain_id"
      filter="search"
      serviceOptions={serviceOptions}
      mapToOptions={mapLabStainsToOption}
      apiService={ApiService.listLabStainLists}
      component={LabStainOption}
      onChange={(v: LabStainResponse) => onChange(v?.object)}
    >
      <LabStainOption object={value} />
    </SelectSearchInput>
  );
};

export default LabStainInput;
